import { PricingType } from "@dune/types";

export const constructionSiteOfferPricingsQueryKeys = {
	all: ["construction-site-offer-pricings"] as const,
	details: () =>
		[...constructionSiteOfferPricingsQueryKeys.all, "details"] as const,
	detail: (constructionSiteOfferId?: number, pricingType?: PricingType) =>
		[
			...constructionSiteOfferPricingsQueryKeys.details(),
			constructionSiteOfferId,
			pricingType,
		] as const,
	detailByConstructionSiteAndBinderWarranty: (
		constructionSiteId: number,
		binderWarrantyId: number,
		pricingType?: PricingType,
	) =>
		[
			...constructionSiteOfferPricingsQueryKeys.details(),
			"by-construction-site-and-binder-warranty",
			constructionSiteId,
			binderWarrantyId,
			pricingType,
		] as const,
	lists: () =>
		[...constructionSiteOfferPricingsQueryKeys.all, "lists"] as const,
};
